export default {
  'Difficulty level': 'Nivel de dificultad',
  'Your bet': 'Apuesta',
  'Start game': 'Jugar',
  'Take prize': 'Coger',
  'Try again': 'Inténtalo de nuevo',
  Bet: 'Apuesta',
  Profit: 'Beneficio',
};
